// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';
import {selx} from 'clsx';

import {SelectTheme} from 'common/components/select/constants';
import {SelectEl} from 'common/components/select';
import {SpinnerEl} from 'common/components/spinner';
import {Placement} from 'common/components/tooltip/types';

import type {DataGroupSelector} from './index';
import styles from './index.module.styl';

export function template(this: DataGroupSelector) {
  const {fetchedDataGroups, selected} = this.state;
  const {t} = this.getContext(`i18n`);

  const isUsers = selected.displayName === `User`;
  const tooltip = isUsers ? t(`data-groups.analyze-by-users-tooltip`) : t(`data-groups.analyze-by-dg-tooltip`);

  return (
    <div
      sel={selx(styles.container)}
      class={{
        [styles.themeBuilder]: this.attr(`theme`) === `builder`,
        [styles.themeDefault]: !this.attr(`theme`),
        [styles.isLoaded]: fetchedDataGroups,
      }}
    >
      <div sel={selx(styles.label)}>{t(`data-groups.analyze-by`)}</div>
      <div sel={selx(`mp-data-group-selector-select-wrapper`)}>
        {!fetchedDataGroups ? (
          <SpinnerEl />
        ) : (
          <SelectEl
            attrs={{
              theme: this.attr(`theme`) === `builder` ? SelectTheme.Builder : SelectTheme.BuilderLight,
              'selected-option': isUsers ? t(`query-builder.dg-user`) : selected.displayName,
              'menu-width': 270,
              tooltip: {
                text: `${tooltip}\n[${t(`common.learn-more`)}](https://help.mixpanel.com/hc/en-us/articles/360025333632)`,
                placement: Placement.Right,
              },
              'always-show-caret': true,
              icon: {rightIcon: `caret-down`},
            }}
            props={{
              sections: this.helpers.getDataGroupsList(),
            }}
            on={{change: this.helpers.clickDataGroupOption}}
          />
        )}
      </div>
    </div>
  );
}
